<div *ngIf="checkViewMode('edit')" class="form-group {{getOptionByKey(attribute,'class')}}" >
  <label>
      {{getOptionByKey(attribute,'hideTitle') == 'true'? '' : getTitle()}}
      <span class="error-indication" *ngIf="isRequired()">{{getError()}}</span>
      <div *ngIf="getOptionByKey(attribute,'tooltip')"
        class="popover-info"
        [popover]="getOptionByKey(attribute,'tooltip')"
        placement="right"
        container="body"
        triggers="mouseenter:mouseleave">
        <i class="fa fa-question-circle"></i>
      </div>
  </label>

  <div class="nps">
    <div class="form-check" *ngFor="let option of attribute.attributes">
        <input class="form-check-input nps-radio"
            type="radio"
            name="{{getTitle()}}"
            value="{{option.key}}"
            id="{{getKeyForIdentifier(attribute.key)}}-{{getKeyForIdentifier(option.key)}}"
            [checked]="isChecked(option)"
            (change)="onValueChange($event)">
        <label class="form-check-label"
            for="{{getKeyForIdentifier(attribute.key)}}-{{getKeyForIdentifier(option.key)}}">
            {{option.value}}
    </label>
    </div>
  </div>
  <div class="nps-legend">
      <span><i class="fa fa-arrow-left"></i>Pouco satisfeito</span>
      <span>Muito satisfeito<i class="fa fa-arrow-right"></i></span>
  </div>
 </div>

<div *ngIf="checkViewMode('view')">
  <p>
   <span> {{getOptionByKey(attribute,'hideTitle') == 'true'? '' : getTitle()}}:</span> {{ getValue() }}
  </p>
</div>

